import React from 'react';
import styled from 'styled-components';

import { Button } from '~/atomic/atom/Button';
import Modal from '~/atomic/molecula/Modal';
import {
  useApplyAbonnementDiscount,
  useDisableAbonnementAutoRenewal,
} from '~/atomic/page/bookSubscriptions/abonnementPage.data';
import {
  PageTitleStyle, TextBoldStyle, TextRegStyle,
} from '~/atomic/Typography';
import { lessThan } from '~/lib/mediaQuery';

type TProps = {
  price: number;
  isOpen: boolean;
  onClose: () => void;
};

export const ApplyAbonnementDiscountModal = ({
  isOpen,
  onClose,
  price,
}: TProps) => {
  const { mutateAsync: disableAbonnementAuthRenewal, isLoading: isLoadingDisableAbonnementAuthRenewal } = useDisableAbonnementAutoRenewal();
  const { mutateAsync: applyAbonnementDiscount, isLoading: isLoadingApplyAbonnementDiscount } = useApplyAbonnementDiscount();

  const getAbonnementDiscount = async () => {
    await applyAbonnementDiscount();
    onClose();
  };

  const cancelAutoRenewalDiscount = async () => {
    await disableAbonnementAuthRenewal();
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      width="550px"
      onCancel={onClose}
    >
      <SCTitle>
        Абонемент за
        {' '}
        {price}
        ₽ в месяц
      </SCTitle>
      <SCContent>
        Специальная цена на абонемент
        {' '}
        <del>299₽</del>
        {' '}
        {price}
        ₽ в месяц
        {' '}
        <br />
        {' '}
        на следующие
        {' '}
        <SCBold>3 продления</SCBold>
        {' '}
        абонемента.
      </SCContent>
      <SCButtons>
        <SCButton
          block
          type="primary"
          size="large"
          onClick={getAbonnementDiscount}
          isLoading={isLoadingApplyAbonnementDiscount}
          disabled={isLoadingDisableAbonnementAuthRenewal}
        >
          Получить скидку
        </SCButton>
        <Button
          block
          size="large"
          onClick={cancelAutoRenewalDiscount}
          isLoading={isLoadingDisableAbonnementAuthRenewal}
          disabled={isLoadingApplyAbonnementDiscount}
        >
          Отключить абонемент
        </Button>
      </SCButtons>
    </Modal>
  );
};

const SCTitle = styled.h3`
  ${PageTitleStyle};
  color: var(--black-color);
  margin-bottom: 42px;
`;

const SCContent = styled.div`
  ${TextRegStyle};
  color: var(--black-color);
`;

const SCBold = styled.span`
  ${TextBoldStyle};
`;

const SCButton = styled(Button)`
  min-width: max-content;

  ${lessThan('xs')} {
    max-width: none;
  }
`;

const SCButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 36px;
  margin-top: 60px;

  ${lessThan('xs')} {
    flex-direction: column;
    gap: 12px;
  }
`;
